"use client"

import { useEffect } from "react"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom" // Import Navigate
import Home from "./components/home"
import CreateAcc from "./components/createAcc"
import Emploi from "./components/emploi"
import Login from "./components/login"
import Notifications from "./components/notifications"
import Payment from "./components/payment"
import PrivateRoute from "./PrivateRoute" // Importer le composant PrivateRoute
import HomeAdmin from "./components/homeAdmin"
import Unauthorized from "./components/Unauthorized"
import ApproverClientPage from "./components/ApproverClientPage"
import AdminNotification from "./components/AdminNotification"
import AdminPaiment from "./components/AdminPaiment"
import AdminChrono from "./components/AdminChrono"
import AdminListeFactures from "./components/AdminListeFactures"
import { NotificationProvider } from "./components/NotificationContext"
import AdminNotifPerso from "./components/AdminNotifPerso"
import AdminGetNotifs from "./components/AdminGetNotifs"
import InstructorHome from "./components/InstructorHome"
import Politique from "./components/Politique"
import Profile from "./components/Profile"
import ProfileAdmin from "./components/ProfileAdmin"
import Checklist from "./components/checklist"
import InstructorChecklist from "./components/InstructorChecklist"
import ClientsDash from "./components/ClientsDash"
import ApprouverClientInstructor from "./components/ApprouverClientInstructor"
import Gestiondestock from "./components/Gestiondestock"
import ConsulterStock from "./components/ConsulterStock"
import MesSeances from "./components/MesSeances"
import AdminBanner from "./components/AdminBanner"
import DetailPension from "./components/DetailPension" // Import the DetailPension component
import AdminCompetitionInvoice from "./components/AdminCompetitionInvoice"
import Suivichevaux from "./components/suivichevaux"
import ReservationBox from "./components/ReservationBox" // Import the ReservationBox component
import AdminReservations from "./components/AdminReservations"
import AdminVaccinsChevaux from "./components/AdminVaccinsChevaux"

function App() {
  // Function to get the user role from localStoragesss
  const getUserRole = () => {
    const user = JSON.parse(localStorage.getItem("user"))
    return user ? user.role : null // Assuming 'role' is a field in the user object
  }

  // Function to get the user ID from localStoragee
  const getUserId = () => {
    const user = JSON.parse(localStorage.getItem("user"))
    return user ? user.id : null // Assuming 'id' is a field in the user object
  }

  // Check if the user is authenticatedd
  const isAuthenticated = () => {
    const token = localStorage.getItem("CC_Token")
    const user = localStorage.getItem("user")
    return token && user
  }

  const userId = getUserId() // Get the logged-in user's ID

  useEffect(() => {
    if ("Notification" in window) {
      Notification.requestPermission()
    }
  }, [])

  return (
    <Router>
      <div className="App">
        <NotificationProvider>
          {" "}
          {/* Global Notificationss */}
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />

            {/* Public routes */}
            <Route
              path="/login"
              element={
                isAuthenticated() ? (
                  <Navigate
                    to={
                      getUserRole() === "admin"
                        ? "/Admin"
                        : getUserRole() === "instructor"
                          ? "/InstructorHome"
                          : "/Home"
                    }
                  />
                ) : (
                  <Login />
                )
              }
            />

            <Route path="/Politique" element={<Politique />} />
            <Route
              path="/register"
              element={
                isAuthenticated() ? <Navigate to={getUserRole() === "admin" ? "/Admin" : "/Home"} /> : <CreateAcc />
              }
            />

            {/* Role-based protected routes */}
            <Route
              path="/Home"
              element={<PrivateRoute element={<Home />} allowedRoles={["member", "instructor", "admin"]} />}
            />
            {/* Add DetailPension route */}
            <Route
              path="/DetailPension"
              element={<PrivateRoute element={<DetailPension />} allowedRoles={["member", "instructor", "admin"]} />}
            />
            {/* Add ReservationBox route */}
           <Route path="/ReservationBox" element={<ReservationBox />} />

             <Route
              path="/AdminReservations"
              element={<PrivateRoute element={<AdminReservations />} allowedRoles={["admin"]} />}
            />

            <Route
              path="/AdminVaccinsChevaux"
              element={<PrivateRoute element={<AdminVaccinsChevaux />} allowedRoles={["admin"]} />}
            />
             
            <Route path="/MesSeances" element={<PrivateRoute element={<MesSeances />} allowedRoles={["member"]} />} />
            <Route
              path="/ConsulterStock"
              element={<PrivateRoute element={<ConsulterStock />} allowedRoles={["admin"]} />}
            />
            <Route
              path="/Gestiondestock"
              element={<PrivateRoute element={<Gestiondestock />} allowedRoles={["admin"]} />}
            />
            <Route
              path="/ApprouverClientInstructor"
              element={<PrivateRoute element={<ApprouverClientInstructor />} allowedRoles={["instructor"]} />}
            />
            <Route
              path="/InstructorChecklist"
              element={<PrivateRoute element={<InstructorChecklist />} allowedRoles={["instructor", "admin"]} />}
            />
            <Route
              path="/InstructorHome"
              element={<PrivateRoute element={<InstructorHome />} allowedRoles={["instructor"]} />}
            />
            <Route
              path="/Profile"
              element={<PrivateRoute element={<Profile />} allowedRoles={["member", "instructor"]} />}
            />
             <Route
              path="/Suivichevaux"
              element={<PrivateRoute element={<Suivichevaux />} allowedRoles={["member", "instructor" ,"admin"]} />}
            />
            <Route
              path="/ProfileAdmin"
              element={<PrivateRoute element={<ProfileAdmin />} allowedRoles={["instructor", "admin"]} />}
            />
            <Route path="/AdminBanner" element={<PrivateRoute element={<AdminBanner />} allowedRoles={["admin"]} />} />
            <Route
              path="/ClientsDash"
              element={<PrivateRoute element={<ClientsDash />} allowedRoles={["instructor", "admin"]} />}
            />
            <Route
              path="/AdminPaiment"
              element={<PrivateRoute element={<AdminPaiment />} allowedRoles={["admin"]} />}
            />
            <Route
              path="/AdminNotificationToClient"
              element={<PrivateRoute element={<AdminNotifPerso />} allowedRoles={["admin", "instructor"]} />}
            />
            <Route
              path="/Checklist"
              element={<PrivateRoute element={<Checklist />} allowedRoles={["admin", "instructor"]} />}
            />
            <Route
              path="/AdminGetNotifs"
              element={<PrivateRoute element={<AdminGetNotifs />} allowedRoles={["admin", "instructor"]} />}
            />

            <Route
              path="/AdminChrono"
              element={<PrivateRoute element={<AdminChrono />} allowedRoles={["admin", "instructor"]} />}
            />
            <Route path="/Admin" element={<PrivateRoute element={<HomeAdmin />} allowedRoles={["admin"]} />} />
            <Route
              path="/AdminNotification"
              element={<PrivateRoute element={<AdminNotification />} allowedRoles={["admin", "instructor"]} />}
            />
            <Route
              path="/ApprouverClient"
              element={<PrivateRoute element={<ApproverClientPage />} allowedRoles={["admin"]} />}
            />
            <Route
              path="/Emploi"
              element={<PrivateRoute element={<Emploi />} allowedRoles={["member", "instructor", "admin"]} />}
            />
            <Route
              path="/Notifications"
              element={<PrivateRoute element={<Notifications />} allowedRoles={["member", "instructor", "admin"]} />}
            />
            <Route
              path="/ConsulterFactures"
              element={<PrivateRoute element={<AdminListeFactures />} allowedRoles={["admin"]} />}
            />
            <Route
              path="/AdminCompetitionInvoice"
              element={<PrivateRoute element={<AdminCompetitionInvoice />} allowedRoles={["admin"]} />}
            />
            <Route
              path="/Payment"
              element={<PrivateRoute element={<Payment />} allowedRoles={["member", "instructor", "admin"]} />}
            />

            {/* Fallback route */}
            <Route path="/not-authorized" element={<Unauthorized />} />
          </Routes>
        </NotificationProvider>
      </div>
    </Router>
  )
}

export default App
